var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"pm-fade-in-slide-up-transition"}},[(_vm.dialog!=='')?_c(_vm.dialog,{ref:"dialog",tag:"component",attrs:{"dialogData":_vm.dialogData},on:{"close":_vm.close}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }